import { GetAttestationData } from '@lyrahealth-inc/shared-app-logic'

import { noOpActionErrorHandler } from '../actionErrorHandler'
import { axiosInstance } from '../axiosInstance'

export const GET_UNIVERSAL_PROPERTIES = 'GET_UNIVERSAL_PROPERTIES'
export const GET_CUSTOMER_COUNTRY_PROPERTIES = 'GET_CUSTOMER_COUNTRY_PROPERTIES'

export function getAttestationData({ customerId, id }: GetAttestationData) {
  return axiosInstance.get(`unsecured/v1/customer/${customerId}/attestation`, { params: { id } })
}

export const getDependentTypesData = ({
  customerId,
  token,
  id,
  isSSO,
}: {
  customerId: string
  token: string
  id: string
  isSSO: string
}) => {
  return axiosInstance.get(`unsecured/v1/customer/${customerId}/dependentType?token=${token}&id=${id}&isSSO=${isSSO}`)
}

export const getUniversalCustomerCountryProperties = ({ countryId }: { countryId: number }) => ({
  action: GET_UNIVERSAL_PROPERTIES,
  request: {
    method: 'get',
    url: `/unsecured/v1/customer/country/${countryId}/properties/universal`,
  },
  errorHandler: noOpActionErrorHandler,
})

export const getCustomerCountryProperties = ({ countryId }: { countryId: number }) => ({
  action: GET_CUSTOMER_COUNTRY_PROPERTIES,
  request: {
    method: 'get',
    url: `/unsecured/v1/customer/country/${countryId}/properties`,
  },
  errorHandler: noOpActionErrorHandler,
})
